import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme/theme';

import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ProcessSection from './components/ProcessSection';
import PortfolioSection from './components/PortfolioSection';
import AutomationSection from './components/AutomationSection';
import WhyEffsos from './components/WhyEffsos';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Navbar />
      <HeroSection />
      <ProcessSection />
      <PortfolioSection />
      <AutomationSection />
      <WhyEffsos />
      <ContactSection />
      <Footer />
      <WhatsAppButton />
    </ThemeProvider>
  );
}

export default App;
